import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";

/**
 * Locale-aware navigation primitives. Import { Link, redirect, usePathname,
 * useRouter } from here instead of next/navigation so the `/<locale>/` prefix is
 * kept automatically.
 */
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
